const data = {
    properties: [
      {
        id: "1",
        tag: "For Rent",
        title: "2 Bedroom Apartment",
        price: "GHC2,200/m",
        address: "Dome",
        bedrooms: 2,
        baths: 4,
        size: 150,
        image: require("./images/home1.jpg"),
        images: [
          {
            url: "https://www.dropbox.com/s/ug3op6ra3akwmtf/domek1.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/pyxwe8msj8k9j4n/domek2.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/2im5rbcd0z6ch98/domek3.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/8x15pzt05a8q0a1/domek4.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/pxtuhylg0b8wr8p/domek5.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/oix8vhy73isczji/domek6.jpg?raw=1"
          }
        ],
        featured: true,
        type: "apartment",
        details: "Brand new two bedroom apartment for rental.",
        marker: {
          address: "Dome, K Boat Junction",
          lat: 5.646477,
          lng: -0.226653
        }
      },
      {
        id: "2",
        tag: "For Rent",
        title: "Newly Built Apartments",
        price: "GHC2,200/m",
        address: "East-Legon",
        marker: {
          address: "East-Legon Hills school junction",
          lat: 5.683475,
          lng: -0.124107
        },
        bedrooms: 3,
        baths: 4,
        size: 150,
        image: require("./images/home2.jpg"),
        images: [
          {
            url: "https://www.dropbox.com/s/aw2xkkfox5exy9m/elh6.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/qiu15bfl9bf66rt/elh5.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/pipdklgtmf5jh2i/elh4.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/s1mn04p0ggaouo1/elh1.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/zlk2u20105nnwb0/elh3.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/rqv463sexb61kfk/elh2.jpg?raw=1"
          }
        ],
        featured: true,
        type: "apartment",
        details:
          "Recently built apartments up for rent at East-legon Hills school junction."
      },
      {
        id: "3",
        tag: "ForSale",
        title: "4 Bedroom House",
        price: "$410,000",
        address: "East-Legon",
        marker: {
          address: "East-Legon",
          lat: 5.635698,
          lng: -0.160204
        },
        bedrooms: 4,
        baths: 4,
        size: 150,
        image: require("./images/home3.jpg"),
        images: [
          {
            url: "https://www.dropbox.com/s/82999utsaayyhoz/4h1.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/0n8xguqk4jzeidl/4h2.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/kklrt37hugl3x73/4h3.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/2qykmzo8874j1nq/4h4.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/u3cx31q1xz9hgcm/4h5.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/3bo5q8yg13q837j/4h6.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/h0mv0kvgpm52wg0/4h7.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/iqhf6k1xwo4a0bf/4h8.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/muatrr5w6vyp4q7/4h9.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/bo9rxy1dxqpk6ct/4h10.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/m8pkh7wru3qz0h9/4h11.jpg?raw=1"
          }
        ],
        featured: true,
        type: "house",
        details: "Modern 4 Bedroom House for sale at East Legon"
      },
      {
        id: "4",
        tag: "For Sale",
        title: "4 Bedroom Ensuit",
        price: "$310,000",
        address: "Spintex",
        marker: {
          address: "Spintex, Baatsonaa",
          lat: 5.62206,
          lng: -0.08785
        },
        bedrooms: 4,
        baths: 4,
        size: 150,
        image: require("./images/home4.jpg"),
        images: [
          {
            url: "https://www.dropbox.com/s/p53uc1vuaz4y8oc/sb2.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/sme669h85n72onb/sb3.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/ard0h868lzn5tre/sb4.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/qdu7djw27ifhoez/sb5.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/jc2tdkeopmub76i/sb6.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/3xspybh3c4crb1u/sb7.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/v089ygoriuamtqp/sb8.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/9s5u2fvgodel19h/sb9.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/pk5qqviymngp30m/sb10.jpg?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/6frp3amhhycivki/sb11.jpg?raw=1"
          }
        ],
        featured: true,
        type: "house",
        details:
          "A moderm 4 Bedroom ensuit house for sale at Baatsonaa, Spintex comes with a fitted Kitchen and Air Conditions"
      },
      {
        id: "5",
        tag: "For Sale",
        title: "3 Bedroom Townhouse",
        price: "$250,000",
        address: "adjiringanor",
        marker: {
          address: "adjiringanor",
          lat: 5.651098,
          lng: -0.135439
        },
        bedrooms: 3,
        baths: 4,
        size: 150,
        image: require("./images/home1.jpg"),
        images: [
          {
            url: "https://www.dropbox.com/s/jqd2utp1jhyiuvv/adj1.JPG?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/xpvksxmqg66ugc0/adj3.JPG?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/k8p4hx19wleovui/adj2.JPG?raw=1"
          },
          {
            url: "https://www.dropbox.com/s/iqendca8q1kt7gf/adj4.JPG?raw=1"
          }
        ],
        featured: false,
        type: "house",
        details:
          "3 bedroom Townhouses for sale at adjiringanor. All bedrooms ensuit, including a guest washroom, fitted kitchen, outhouse, compound can take 3 cars, tarred road network"
      },
      {
        id: "6",
        tag: "For Sale",
        title: "Luxury Apartment",
        price: "120,000",
        address: "Sakumono",
        marker: {
          address: "Sakumono",
          lat: 5.623547,
          lng: -0.061305
        },
        bedrooms: 3,
        baths: 4,
        size: 150,
        image: require("./images/home1.jpg"),
        featured: false,
        type: "apartment",
        details:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat"
      },
      {
        id: "7",
        tag: "For Sale",
        title: "156 Acres of Farm Land",
        price: "GHC26,000/acre",
        address: "Aburi Fotobi",
        marker: {
          address: "Aburi Fotobi",
          lat: 5.81313,
          lng: -0.267449
        },
        bedrooms: null,
        baths: null,
        size: 180,
        image: require("./images/land.jpg"),
        featured: false,
        type: "land",
        details:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat"
      },
      {
        id: "8",
        tag: "For Sale",
        title: "150 Acres of Farm Land",
        price: "GHC6,000/acre",
        address: "Nsawam Pokrom",
        marker: {
          address: "Nsawam Pokrom",
          lat: 5.817715,
          lng: -0.317831
        },
        bedrooms: null,
        baths: null,
        size: 150,
        image: require("./images/land.jpg"),
        featured: false,
        type: "land",
        details:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat"
      },
      {
        id: "9",
        tag: "For Sale",
        title: "100 Acres",
        price: "GHC150/acre",
        address: "Winneba",
        marker: {
          address: "Winneba",
          lat: 5.383957,
          lng: -0.644618
        },
        bedrooms: null,
        baths: null,
        size: null,
        image: require("./images/land.jpg"),
        featured: false,
        type: "land",
        details:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat"
      },
      {
        id: "10",
        tag: "For Sale",
        title: "10 Plots",
        price: "50,000",
        address: "Sakumono",
        marker: {
          address: "Sakumono",
          lat: 5.623547,
          lng: -0.061305
        },
        bedrooms: null,
        baths: null,
        size: 150,
        image: require("./images/land.jpg"),
        featured: false,
        type: "land",
        details:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat"
      }
    ]
  };
  
  export default data;
  